//console.log('beauty clout affiliates');
window.onload = function(e) {
	const urlSearchParams = new URLSearchParams(window.location.search);

	const params = Object.fromEntries(urlSearchParams.entries());

	var affiliate = params.bc_aff_id;

	if (affiliate) {
		var date = new Date;
		date.setDate(date.getDate() + 30);

		document.cookie = "bc_id="+affiliate+"; expires="+date+"; path=/";


		const formData = new FormData();

		formData.append('proposal_id', affiliate);
		formData.append('action', 'view');

		fetch('https://beautyclout.dev/api/affiliate', {
			method: 'POST',
			body: formData
		}).then(function(resp) {
			return resp.json();
		}).then(function(json) {
			//console.log(json);
		});

	}

	var pathname = window.location.pathname;

	regex = new RegExp('/([0-9]+)/checkouts/([a-z0-9-]+)/thank_you');

	if (regex.test(pathname) == true) {

		var affiliate_id = null;
		var cookies = document.cookie.split('; ');

		for(var i = 0; i < cookies.length; i++) {
			var pair = cookies[i].split('=');

			if (pair[0] == 'bc_id') {
				affiliate_id = pair[1];
			}
		}



		if (affiliate_id != null) {
			
			const formData = new FormData();

			formData.append('proposal_id', affiliate_id);
			formData.append('order_id', Shopify.checkout.order_id);
			formData.append('action', 'order');

			fetch('https://beautyclout.dev/api/affiliate', {
				method: 'POST',
				body: formData
			}).then(function(resp) {
				return resp.json();
			}).then(function(json) {
				
			});

		}

		
	}

	

};
